import { render, staticRenderFns } from "./FavoriteSearchComponent.vue?vue&type=template&id=52ee1c88&"
import script from "./FavoriteSearchComponent.vue?vue&type=script&lang=js&"
export * from "./FavoriteSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteSearchComponent.vue?vue&type=style&index=0&id=52ee1c88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports